<template>
  <div>
    <!-- <h5 class="text-secondary font-weight-bold">I tuoi orari di ricevimento sull'app</h5>
    <br />-->
    <b-overlay :show="loading" rounded="sm">
      <div class="col-sm-12 col-lg-10 mx-auto my-2">
        <h5 class="text-secondary font-weight-bold">
          Quanto tempo vuoi dedicare a ciascun consulto?
        </h5>
        <div>
          <b-form-radio-group
            v-model="intervallo"
            :options="options"
            name="radio-options"
            class="text-secondary"
            :class="isMobile && 'd-flex justify-content-center'"
          ></b-form-radio-group>
        </div>
      </div>
      <br />
      <div class="col-sm-12 col-lg-11 mx-auto my-2">
        <h5 class="text-secondary font-weight-bold">
          Quali giorni della settimana vuoi dedicare al teleconsulto?
        </h5>
        <br />
        <div v-if="isMobile" class="d-flex flex-wrap justify-content-center">
          <span
            v-for="(giorno, ind) in giorni"
            :key="ind"
            class="text-white col-5 p-0 mx-1 my-3 py-1 point"
            :class="
              giorno.selected == true ? 'bg-secondary' : 'bg-disabled-grey'
            "
            @click="giorno.selected = !giorno.selected"
            >{{ giorno.giorno }}</span
          >
        </div>
        <div v-else>
          <span
            v-for="(giorno, ind) in giorni"
            :key="ind"
            class="text-white col-3 py-1 mx-2 point"
            :class="
              giorno.selected == true ? 'bg-secondary' : 'bg-disabled-grey'
            "
            @click="giorno.selected = !giorno.selected"
            >{{ giorno.giorno }}</span
          >
        </div>
      </div>
      <br />
      <div class="col-sm-12 col-lg-11 mx-auto my-2">
        <h5 class="text-secondary font-weight-bold">
          Imposta orari per i giorni selezionati
        </h5>
        <!-- <input type="time" /> -->
        <div v-for="(giorno, ind) in giorni" :key="ind">
          <div
            v-if="giorno.selected"
            class="border border-secondary p-1 bg-light my-2"
          >
            <h5
              class="text-secondary font-weight-bold text-left text-capitalize"
            >
              {{ giorno.giorno }}
            </h5>
            <div class="d-flex" :class="isMobile && 'flex-wrap'">
              <label class="text-secondary">Orario inizio:</label>
              <b-input-group
                class="mb-3"
                :class="isMobile ? 'col-12' : 'col-5'"
              >
                <b-form-input
                  v-model="giorno.ora_inizio"
                  type="time"
                  placeholder="HH:mm"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-timepicker
                    v-model="giorno.ora_inizio"
                    button-only
                    right
                    v-bind="it"
                    :local="it"
                    aria-controls="example-input"
                  ></b-form-timepicker>
                </b-input-group-append>
              </b-input-group>
              <label class="text-secondary">Orario fine:</label>
              <b-input-group
                class="mb-3"
                :class="isMobile ? 'col-12' : 'col-5'"
              >
                <b-form-input
                  v-model="giorno.ora_fine"
                  type="time"
                  placeholder="HH:mm"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-timepicker
                    v-model="giorno.ora_fine"
                    button-only
                    right
                    v-bind="it"
                    :local="it"
                    aria-controls="example-input"
                  ></b-form-timepicker>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </div>
      </div>
      <div class="col-10 mx-auto my-2">
        <b-button variant="primary font-weight-bold mt-3" @click="elaborate"
          >Imposta Orari</b-button
        >
      </div>
    </b-overlay>
  </div>
</template>
<script>
// @ is an alias to /src
import moment from "moment";
export default {
  name: "impostazione-orari",
  data() {
    return {
      tipo: this.$route.params.tipo,
      loading: true,
      prevSel: [],
      intervallo: 15,
      options: [
        { text: "10 minuti", value: 10 },
        { text: "15 minuti", value: 15 },
        { text: "20 minuti", value: 20 },
      ],
      it: {
        labelHours: "Ore",
        labelMinutes: "Minuti",
        labelSeconds: "Secondi",
        labelIncrement: "Erhöhen",
        labelDecrement: "Verringern",
        labelSelected: "Ausgewählte Zeit",
        labelNoTimeSelected: "Nessun tempo selezionato",
        labelCloseButton: "Chiudi",
      },
      giorni: [
        {
          giorno: "lunedì",
          selected: false,
          ora_inizio: null,
          ora_fine: null,
          slot: 0,
        },
        {
          giorno: "martedì",
          selected: false,
          ora_inizio: null,
          ora_fine: null,
          slot: 0,
        },
        {
          giorno: "mercoledì",
          selected: false,
          ora_inizio: null,
          ora_fine: null,
          slot: 0,
        },
        {
          giorno: "giovedì",
          selected: false,
          ora_inizio: null,
          ora_fine: null,
          slot: 0,
        },
        {
          giorno: "venerdì",
          selected: false,
          ora_inizio: null,
          ora_fine: null,
          slot: 0,
        },
      ],
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    },
  },
  methods: {
    getOwn() {
      var url = process.env.VUE_APP_VERSION + "ricevimento/own";
      this.$axios
        .get(url)
        .then((res) => {
          // console.log(res.data.data);
          // if (res.data.data != null) {
          res.data.data.map((val) => {
            this.giorni.forEach((el) => {
              if (val.giorno === el.giorno) {
                el.ora_inizio = val.ora_inizio;
                el.ora_fine = val.ora_fine;
                el.slot = val.slot;
                el.selected = true;
              }
            });
            this.prevSel.push(val.giorno);
            this.intervallo = val.intervallo;
          });
          // }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showval() {
      // console.log(this.giorni);
      this.elaborate();
    },
    elaborate() {
      this.loading = true;
      this.giorni.forEach((giorno) => {
        if (giorno.selected) {
          var start = new moment(giorno.ora_inizio, "LTS");
          var end = new moment(giorno.ora_fine, "LTS");
          if (end.isBefore(start)) {
            return alert("orario ora_fine precede orario ora_inizio");
          }
          var duration = moment.duration(end.diff(start)).as("minutes");
          var units = Math.floor(duration / this.intervallo);
          giorno.slot = units;

          if (this.prevSel.includes(giorno.giorno)) {
            this.update(giorno);
          } else {
            this.store(giorno);
          }
        }
        if (giorno.giorno == "venerdì") {
          this.$bvToast.toast(
            `I tuoi orari di ricevimento sono stati aggiornati`,
            {
              title: "Orari ricevimento aggiornati!",
              autoHideDelay: 3000,
              variant: "secondary",
            }
          );
        }
      });
    },
    store(giorno) {
      if (giorno.ora_inizio == null || giorno.ora_fine == null) {
        return "";
      }
      var url = process.env.VUE_APP_VERSION + "ricevimento";
      var data = giorno;
      data.intervallo = this.intervallo;
      this.$axios
        .post(url, data)
        .then((res) => {
          // console.log(res);

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    update(giorno) {
      var url = process.env.VUE_APP_VERSION + "ricevimento";
      var data = giorno;
      data.intervallo = this.intervallo;
      this.$axios
        .put(url, data)
        .then((res) => {
          // console.log(res);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getOwn();
  },
};
</script>
